import React, { createContext, useState, useContext, JSX } from 'react'
import { useNavigate } from 'react-router'
import * as qs from 'qs'

//evertel
import { DocumentModal } from './DocumentModal'

export interface DocumentModalContext {
    openDocumentModal: (documentId: number) => void
    closeDocumentModal: () => void
}
export interface DocumentModalProps {
    children: React.ReactNode
}

export const DocumentModalContext = createContext<DocumentModalContext>({
    openDocumentModal: (documentId: number) => {
        //
    },
    closeDocumentModal: () => {
        //
    }
})

export const DocumentModalContextProvider: React.FC<DocumentModalProps> = ({
    children
}) => {

    const [visible, setVisible] = useState(false)
    const [documentId, setDocumentId] = useState(0)
    const navigate = useNavigate()

    const updateQueryString = async (params: any) => {
        const currentQuery = qs.parse(window.location.search, { ignoreQueryPrefix: true })
        const newQuery = { ...currentQuery, ...params }
        const searchParams = qs.stringify(newQuery)
        await navigate(`${window.location.pathname}?${searchParams}`, { replace: true })
    }

    const openDocumentModal = (documentId: number) => {
        updateQueryString({ selectedDoc: documentId })

        setDocumentId(documentId)
        setVisible(true)
    }

    const closeDocumentModal = () => {
        updateQueryString({ selectedDoc: undefined })
        setVisible(false)
    }

    const onEdit = async () => {
        await updateQueryString({ selectedDoc: undefined })
        navigate(`/everdocs/edit/${documentId}`)
        // closeDocumentModal() //closing this overwrites the navigation
    }

    return (
        <DocumentModalContext.Provider value={{ openDocumentModal, closeDocumentModal }}>
            {children}
            <DocumentModal
                visible={visible}
                documentId={documentId}
                onEdit={onEdit}
                onClose={closeDocumentModal}
            />
        </DocumentModalContext.Provider>
    )
}

export const DocumentModalConsumer = DocumentModalContext.Consumer

export const useDocumentModal = () => {
    return useContext(DocumentModalContext)
}
